<template>
	<div>
		<div class="row">
			<div class="col-md-12">
				<div class="card">
					<div class="card-header">Платежи за периоды
						<div class="card-header-actions">
							<b-button variant="primary" class="card-header-actions__item" @click="$router.push({path: '/payments/create/'})"><i class="fa fa-plus"></i> Создать платёж</b-button>
							<b-form inline class="card-header-actions__item">
								<label for="payment-rows-number" class="mr-2">Количество:</label>
								<b-form-select
									id="payment-rows-number"
									v-model="paymentRows"
									:options="paymentRowsNumber"
									@change="onChangePaynetRows"></b-form-select>
							</b-form>
						</div>
					</div>
					<div class="card-body">
						<vuetable ref="vuetable"
							:fields="columns"
							:api-mode="false"
							:data="tableData"
							@vuetable:row-dblclicked="rowClickHandler"
							class="table-striped"
							noDataTemplate="Ничего не найдено">
							<template slot="date_start" slot-scope="props" data-id="111">
								{{ dateFormat(props.rowData.date_start) }}
							</template>
							<template slot="date_end" slot-scope="props">
								{{ dateFormat(props.rowData.date_end) }}
							</template>
							<template slot="sum" slot-scope="props">
								{{ props.rowData.sum | currency}}
							</template>
							<template slot="sum_b24" slot-scope="props">
								{{ props.rowData.sum_b24 | currency}}
							</template>
							<template slot="diff" slot-scope="props">
								<b-badge :variant="props.rowData.sum - props.rowData.sum_b24 !== 0 ? 'warning' : 'success'">
									{{ props.rowData.sum - props.rowData.sum_b24 | currency }}
								</b-badge>
							</template>
						</vuetable>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import moment from 'moment'
export default {
	data () {
		return {
			paymentRows: 5,
			paymentRowsNumber: Array.from({length: 54}, (v, k) => k + 1),
			tableData: [],
			columns: [
				{
					name: '__slot:date_start',
					title: 'период с...'
				}, {
					name: '__slot:date_end',
					title: 'период по...'
				}, {
					name: 'count',
					title: 'Кол-во платежей'
				}, {
					name: '__slot:sum',
					title: 'Сумма'
				}, {
					name: '__slot:sum_b24',
					title: 'Сумма (Б24)'
				}, {
					name: '__slot:diff',
					title: 'Разница'
				}
			]
		}
	},
	mounted () {
		this.getPayments()
	},
	methods: {
		getPayments (rows = null) {
			const queryParams = {
				rows: rows
			}
			this.$store.commit('CALL_API_ON')
			this.$http.get(this.$store.state.apiURL + '/v1/payment/periods', {params: queryParams}, {
			}).then(function (response) {
				this.tableData = response.body
				this.$store.commit('CALL_API_OFF')
			}, function (response) {
			})
		},
		dateFormat: function (date) {
			return moment(date).format('DD.MM.Y')
		},
		getDifferent (sum, sum2) {
			if (sum - sum2 === 0) {
				return '<span class="el-tag el-tag--success">' + this.$options.filters.currency(sum - sum2) + '</span>'
			} else {
				return '<span class="el-tag el-tag--warning">' + this.$options.filters.currency(sum - sum2) + '</span>'
			}
		},
		rowClickHandler (row, event) {
			this.$router.push({path: '/payments/list/trash', query: {date_start: row.date_start}})
		},
		onChangePaynetRows () {
			this.getPayments(this.paymentRows)
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/pages/payment/period.vue